import React from 'react';
import {
  branch,
  compose,
  renderNothing
} from 'recompose';
import {
  Button
} from 'react-bootstrap';
import {
  Icon, SubmissionMessage
} from './';
import {
  focusElement
} from '../../services';

const FormSubmissionMessage = ({
  className,
  focusMessage,
  stopFocusingMessage,
  error,
  submissionMessage,
  hideSubmissionMessage
}) => (
    <SubmissionMessage
      innerClassName={className}
      innerRef={(messageRef) => {
        if (messageRef && focusMessage) {
          focusElement(messageRef);
          stopFocusingMessage();
        }
      }}
      success={!error}
    >
      {
        error || submissionMessage
      }
      <Button
        bsStyle='plain'
        className='pull-right full-width'
        onClick={hideSubmissionMessage}>
        <Icon icon='close' />
      </Button>
    </SubmissionMessage>);

export default compose(
  branch(
    ({ showSubmissionMessage }) => !showSubmissionMessage,
    renderNothing
  )
)(FormSubmissionMessage);



// WEBPACK FOOTER //
// ./src/containers/components/form-submission-message.js